module.exports = __webpack_public_path__ + "img/symbol_6.c6c81cc0.png";